var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-popover",
    {
      staticClass: "d-inline",
      attrs: { "popover-class": "v-popover--dropdown" }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "VsMenu",
        {
          attrs: { slot: "popover", buttons: _vm.actionGeneratorMixin_actions },
          slot: "popover"
        },
        [_vm._t("menu")],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }